
import { defineComponent } from 'vue';
import { PER_PAGE, DEFAULT_AVATAR_URL } from '@/const';
import { ICloud, IExtension, IHost, ITheme, IUser } from '@/types/models';
import api, { IResourceAddRequest } from '@/api/admin/users';
import utils from '@/utils';
import { IElForm } from '@/types/element';

interface IForm {
  id: string;
  keyword: string;
  currentPage: number;
  offset: number;
  limit: number;
}

interface IState {
  DEFAULT_AVATAR_URL: string;
  items: IUser[];
  count: number;
  formInline: IForm;
  user: IUser;
  isFormAdd: boolean;
  isResources: boolean;
  hosts: IHost[];
  clouds: ICloud[];
  themes: ITheme[];
  extensions: IExtension[];
  resourceAddForm: IResourceAddRequest;
}

export default defineComponent({
  data() {
    return {
      DEFAULT_AVATAR_URL,
      items: [],
      count: 0,
      formInline: {
        id: '',
        keyword: '',
        currentPage: 1,
        offset: 0,
        limit: PER_PAGE,
      },
      user: {} as IUser,
      isFormAdd: false,
      isResources: false,
      hosts: [],
      clouds: [],
      themes: [],
      extensions: [],
      resourceAddForm: {} as IResourceAddRequest,
    } as IState;
  },
  methods: {
    apiGet() {
      api.get(this.formInline, (res) => {
        if (!res) return;

        this.items = res.items;
        this.count = res.count;
      });
    },

    apiDelete(user: IUser) {
      api.delete(user.id, (res) => {
        if (!res) return;

        utils.success(`用户 ${user.userName} 删除成功！`);
        this.apiGet();
      });
    },

    apiResources(userId: number) {
      api.resources(userId, (res) => {
        if (!res) return;

        this.isResources = true;
        this.hosts = res.hosts;
        this.clouds = res.cloud != null ? [res.cloud] : [];
        this.themes = res.themes;
        this.extensions = res.extensions;
      });
    },

    apiResourceAdd() {
      this.resourceAddForm.userId = this.user.id;
      api.resourceAdd(this.resourceAddForm, (res) => {
        if (!res) return;

        utils.success('资源添加成功！');
        this.resourceAddForm = {} as IResourceAddRequest;
        this.apiResources(this.user.id);
      });
    },

    getHostName(host: IHost) {
      return utils.getHostUniqueName(host);
    },

    getHostType(host: IHost) {
      return utils.getHostType(host.hostType);
    },

    getCloudType(cloud: ICloud) {
      return utils.getCloudType(cloud.cloudType);
    },

    getUrl(hostName: string, nodeName: string, isHongKong: boolean): string {
      return utils.getHostUrl(hostName, nodeName, isHongKong);
    },

    formReset() {
      const form = this.$refs.form as IElForm;
      form.clearValidate();
    },

    btnSearchClick() {
      this.apiGet();
    },

    btnEditClick(user: IUser) {
      this.user = { ...user };
      this.isFormAdd = true;
    },

    btnResourcesClick(user: IUser) {
      this.user = { ...user };
      this.apiResources(this.user.id);
    },

    btnSubmitClick() {
      (this.$refs.form as IElForm).validate((valid) => {
        if (valid) {
          api.submit(this.user, (res) => {
            if (!res) return;
            this.isFormAdd = false;
            this.apiGet();
            utils.success(`用户${this.user.id > 0 ? '修改' : '添加'}成功`);
          });
        }
      });
    },

    btnDeleteClick(user: IUser) {
      utils.alertDelete(
        {
          title: '删除用户',
          text: `此操作将删除用户 ${user.userName}，确定吗？`,
          button: '确认删除',
        },
        () => {
          this.apiDelete(user);
        },
      );
    },

    btnAddResourceClick(resource: string) {
      this.resourceAddForm.resourceType = resource;
    },

    btnAddResourceSubmitClick() {
      (this.$refs.resourceAddForm as IElForm).validate((valid) => {
        if (valid) {
          this.apiResourceAdd();
        }
      });
    },

    handleCurrentChange(val: number) {
      this.formInline.currentPage = val;
      this.formInline.offset = this.formInline.limit * (val - 1);

      this.btnSearchClick();
    },
  },
  mounted() {
    this.apiGet();
  },
});
